import type { RootStackParamList } from "../../../../../../navigation/types";

import { Text, type TextRef } from "../../../../../../../../mads";
import useFocusOnNavigation from "../../../../../../hooks/useFocusOnNavigation";

import { useRoute, type RouteProp } from "@react-navigation/native";
import React, { useRef } from "react";
import { StyleSheet } from "react-native";

export function CollectionModalHeader() {
  const route = useRoute<RouteProp<RootStackParamList, "CollectionModal">>();
  const titleRef = useRef<TextRef>(null);

  // Get the title from route params
  const title = route.params?.title || "";

  // Focus the title when the screen comes into focus for better accessibility
  useFocusOnNavigation(titleRef);

  return (
    <Text
      ref={titleRef}
      numberOfLines={1}
      sx={styles.headerTitle}
      accessible={true}
      accessibilityRole="header"
      ariaLabel={title}
    >
      {title}
    </Text>
  );
}

const styles = StyleSheet.create({
  headerTitle: {
    fontSize: 17,
    fontWeight: "400",
    color: "#000",
  },
});
